import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

const swiperOptions = {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 30,
  speed: 1000,

  navigation: {
    nextEl: '.testimonials .swiper-button-next',
    prevEl: '.testimonials .swiper-button-prev',
  },
};

function Testimonials() {
  return (
    <div className="sec-box testimonials section-padding">
      <div className="pad-left">
        <div className="sec-head mb-80 wow fadeInUp">
          <div className="row">
            <div className="col-lg-7">
              <h6 className="sub-title opacity-7 mb-15">Testimonials</h6>
              <h3>
                Trusted by <span className="main-color">Hundered Clients</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-9">
            <div className="testim-swiper wow fadeIn">
              {/* <div className="testim"> */}
              <Swiper
                id="content-carousel-container-unq-testim"
                className="swiper-container"
                {...swiperOptions}
              >
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item ">
                    <div className="icon-img-60 mr-60">
                      <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                    </div>

                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                             
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        Haris delivered our mobile app faster than expected and with flawless quality. The UI feels modern, animations are smooth, and the performance is excellent. Communication was clear throughout the project, and updates were consistent. Working with him was very professional, making the development process effortless and enjoyable.                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Emma Collins</h6>
                            <span className="fz-13 mt-10 opacity-8">
                            E-Commerce Manager
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item d-flex">
                    <div>
                      <div className="icon-img-60 mr-60">
                        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                      </div>
                    </div>
                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                              
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        Our Flutter app turned out amazing thanks to Haris. He guided us at every step, suggested features that boosted engagement, and ensured timely delivery. The interface is intuitive, the flow is seamless, and overall performance exceeded expectations. His attention to detail and professional approach made this collaboration smooth and satisfying.
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Daniel Reyes</h6>
                            <span className="fz-13 mt-10 opacity-8">
                            Startup Founder
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item ">
                    <div className="icon-img-60 mr-60">
                      <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                    </div>

                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                             
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        We needed AI integration for our fitness app, and Haris made it completely effortless. The chatbot works perfectly, responding intelligently to user inputs, and the app feels stable across devices. His technical expertise and clear communication ensured a smooth process, and the final product exceeded our expectations in every aspect.
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Lucas Martin</h6>
                            <span className="fz-13 mt-10 opacity-8">
                            Technical Project Lead
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item d-flex">
                    <div>
                      <div className="icon-img-60 mr-60">
                        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                      </div>
                    </div>
                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                            
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        Haris built a robust React Native app for our e-commerce brand. The app is fast, reliable, and beautifully designed. Every feature works perfectly, the UI is elegant, and performance is flawless. Communication was clear, updates were timely, and the project ran smoothly from start to finish. Highly recommended developer.
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Miguel Torres</h6>
                            <span className="fz-13 mt-10 opacity-8">
                            E-Commerce Manager
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item ">
                    <div className="icon-img-60 mr-60">
                      <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                    </div>

                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                             
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        Incredible developer! Our previous app had major bugs, but Haris refactored everything. It is now stable, smooth, and works perfectly across devices. He addressed every concern quickly, provided updates consistently, and ensured the final product exceeded our expectations. His professionalism and dedication made the experience very positive.
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Olivia Meyer</h6>
                            <span className="fz-13 mt-10 opacity-8">
                              Product Manager
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: '400px' }}>
                  <div className="item d-flex">
                    <div>
                      <div className="icon-img-60 mr-60">
                        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
                      </div>
                    </div>
                    <div>
                      <div className="cont mb-30">
                        <div className="d-flex align-items-center">
                          <div className="rate-stars fz-12">
                            <span className="rate main-color">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span>
                            <span className="fz-12 opacity-7 ml-10">
                              
                            </span>
                          </div>
                        </div>
                        <p className="fz-20 mt-15">
                        Haris built our education app from scratch using Flutter. Animations are fluid, the flow is intuitive, and AI recommendations add real value. Communication was seamless, every stage managed professionally, and the final app feels polished and engaging. Students and educators find it easy to use, making the app highly successful and functional.
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div>
                          {/* <div className="img">
                            <img src="/assets/imgs/testim/1.jpg" alt="" />
                          </div> */}
                        </div>
                        <div className="ml-30">
                          <div className="info">
                            <h6 className="main-color">Noah Kim</h6>
                            <span className="fz-13 mt-10 opacity-8">
                            EdTech Founder
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>



                <SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
            <span className="fz-12 opacity-7 ml-10"></span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          He handled backend APIs, mobile deployment, and everything in between professionally. Updates were clear and consistent, and he ensured the app was scalable and reliable. Every feature worked as expected, and the overall process was smooth. Collaborating with him was efficient, stress-free, and highly productive.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Liam Foster</h6>
            <span className="fz-13 mt-10 opacity-8">CTO</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
            <span className="fz-12 opacity-7 ml-10"></span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          We wanted a modern app with AI features, and Haris exceeded our expectations. The user experience is smooth, performance is excellent, and clients love it. He suggested improvements that enhanced usability and maintained professional communication throughout the project. Delivering such a polished app was truly impressive.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Amelia Rossi</h6>
            <span className="fz-13 mt-10 opacity-8">Digital Product Strategist</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
            <span className="fz-12 opacity-7 ml-10"></span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Super quick turnaround and top-quality code. Haris understood our requirements instantly, created a scalable app, and ensured all features were seamless. The interface is clean, performance smooth, and updates handled efficiently. Clear communication and professional expertise made this collaboration highly effective and enjoyable.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Ethan Rivera</h6>
            <span className="fz-13 mt-10 opacity-8">Mobile Solutions Architect</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>



<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Our healthcare app now runs flawlessly thanks to Haris. Backend optimization improved speed significantly, and the app works reliably across devices. Technical challenges were handled expertly, and communication kept us fully informed. The app is professional, intuitive, and highly functional, exceeding all expectations.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Chloe Nguyen</h6>
            <span className="fz-13 mt-10 opacity-8">Healthcare Tech Manager</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Haris developed our logistics app with precision. Real-time tracking is flawless, the UI looks stunning, and performance is smooth. Every feature works seamlessly, and he managed the project professionally from start to finish. Communication was clear, updates were consistent, and working with him was a highly positive experience.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Johannes Keller</h6>
            <span className="fz-13 mt-10 opacity-8">Operations Director</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Haris turned our idea into a sleek React Native app. Performance is smooth, the design is modern, and all deadlines were met. His attention to detail and technical expertise ensured a polished app that runs reliably across devices. The development process was clear, professional, and efficient.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Carlos Domínguez</h6>
            <span className="fz-13 mt-10 opacity-8">Startup Founder</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          We worked with Haris on a custom CRM mobile app. Design, functionality, and AI integration were executed perfectly. The app is intuitive, fast, and reliable. Communication was clear throughout, and he ensured that every requirement was met. His professionalism and skill made this collaboration highly successful.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Anastasia Morozova</h6>
            <span className="fz-13 mt-10 opacity-8">Project Coordinator</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Excellent developer! Haris built an AI-powered booking app that runs smoothly across platforms. Features are reliable, the interface is modern, and the app is highly functional. His attention to detail and professional approach ensured a successful project with a polished final product that exceeded expectations.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Natalia Petrova</h6>
            <span className="fz-13 mt-10 opacity-8">Product Manager</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide style={{ height: '400px' }}>
  <div className="item d-flex">
    <div>
      <div className="icon-img-60 mr-60">
        <img src="/assets/imgs/svg-assets/quote.png" alt="" />
      </div>
    </div>
    <div>
      <div className="cont mb-30">
        <div className="d-flex align-items-center">
          <div className="rate-stars fz-12">
            <span className="rate main-color">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </span>
          </div>
        </div>
        <p className="fz-20 mt-15">
          Working with Haris was simple and professional. Our Flutter app runs smoothly, the design is clean, and all features work perfectly. He provided excellent support after delivery, ensuring everything was functioning correctly. His communication and expertise made the project highly efficient and enjoyable.
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div></div>
        <div className="ml-30">
          <div className="info">
            <h6 className="main-color">Julia Weber</h6>
            <span className="fz-13 mt-10 opacity-8">Marketing Director</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>



              </Swiper>
              {/* </div> */}
            </div>
          </div>
          <div className="col-lg-3 d-flex align-items-end justify-content-end">
            <div className="swiper-controls testim-controls arrow-out d-flex mr-20 ml-auto">
              <div
                className="swiper-button-prev swiper-button-disabled"
                tabIndex="0"
                role="button"
                aria-label="Previous slide"
                aria-disabled="true"
              >
                <span className="left">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.2031 10.3281L11.5781 15.9531C11.535 15.9961 11.4839 16.0303 11.4276 16.0536C11.3713 16.077 11.3109 16.089 11.25 16.089C11.1891 16.089 11.1287 16.077 11.0724 16.0536C11.0161 16.0303 10.965 15.9961 10.9219 15.9531C10.8788 15.91 10.8446 15.8588 10.8213 15.8025C10.798 15.7462 10.786 15.6859 10.786 15.6249C10.786 15.564 10.798 15.5036 10.8213 15.4473C10.8446 15.391 10.8788 15.3399 10.9219 15.2968L15.7422 10.4687H3.125C3.00068 10.4687 2.88145 10.4193 2.79354 10.3314C2.70564 10.2435 2.65625 10.1242 2.65625 9.99993C2.65625 9.87561 2.70564 9.75638 2.79354 9.66847C2.88145 9.58056 3.00068 9.53118 3.125 9.53118H15.7422L10.9219 4.70305C10.8349 4.61603 10.786 4.498 10.786 4.37493C10.786 4.25186 10.8349 4.13383 10.9219 4.0468C11.0089 3.95978 11.1269 3.91089 11.25 3.91089C11.3731 3.91089 11.4911 3.95978 11.5781 4.0468L17.2031 9.6718C17.2476 9.71412 17.2829 9.76503 17.3071 9.82143C17.3313 9.87784 17.3438 9.93856 17.3438 9.99993C17.3438 10.0613 17.3313 10.122 17.3071 10.1784C17.2829 10.2348 17.2476 10.2857 17.2031 10.3281Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                className="swiper-button-next ml-50"
                tabIndex="0"
                role="button"
                aria-label="Next slide"
                aria-disabled="false"
              >
                <span className="right">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.2031 10.3281L11.5781 15.9531C11.535 15.9961 11.4839 16.0303 11.4276 16.0536C11.3713 16.077 11.3109 16.089 11.25 16.089C11.1891 16.089 11.1287 16.077 11.0724 16.0536C11.0161 16.0303 10.965 15.9961 10.9219 15.9531C10.8788 15.91 10.8446 15.8588 10.8213 15.8025C10.798 15.7462 10.786 15.6859 10.786 15.6249C10.786 15.564 10.798 15.5036 10.8213 15.4473C10.8446 15.391 10.8788 15.3399 10.9219 15.2968L15.7422 10.4687H3.125C3.00068 10.4687 2.88145 10.4193 2.79354 10.3314C2.70564 10.2435 2.65625 10.1242 2.65625 9.99993C2.65625 9.87561 2.70564 9.75638 2.79354 9.66847C2.88145 9.58056 3.00068 9.53118 3.125 9.53118H15.7422L10.9219 4.70305C10.8349 4.61603 10.786 4.498 10.786 4.37493C10.786 4.25186 10.8349 4.13383 10.9219 4.0468C11.0089 3.95978 11.1269 3.91089 11.25 3.91089C11.3731 3.91089 11.4911 3.95978 11.5781 4.0468L17.2031 9.6718C17.2476 9.71412 17.2829 9.76503 17.3071 9.82143C17.3313 9.87784 17.3438 9.93856 17.3438 9.99993C17.3438 10.0613 17.3313 10.122 17.3071 10.1784C17.2829 10.2348 17.2476 10.2857 17.2031 10.3281Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span className="icon-qoute">
        <i className="fas fa-quote-left"></i>
      </span>
    </div>
  );
}

export default Testimonials;
